export enum AlertPresentationStyle {
    Standard = 0,
    Small = 1,
    Icon = 2
}

export interface EntityAlertConfiguration {
    enabled: boolean;
    color: string;
    presentationStyle: AlertPresentationStyle;
}

export interface EntityAlertConfigurations {
    [alertName: string]: EntityAlertConfiguration;
}

export class EntityAlertConfiguration implements EntityAlertConfiguration {
    public enabled: boolean;
    public color: string;
    public presentationStyle: AlertPresentationStyle;

    constructor(obj?: Partial<EntityAlertConfiguration>) {
        this.enabled = obj?.enabled ?? true;
        this.color = obj?.color ?? "blue";
        this.presentationStyle = obj?.presentationStyle ?? AlertPresentationStyle.Standard;
    }
}

export const SUPPORTED_ALERT_COLORS = [
    { value: "red", text: "Red", cssVar: "--red" },
    { value: "purple", text: "Purple", cssVar: "--purple" },
    { value: "green", text: "Green", cssVar: "--green" },
    { value: "orange", text: "Orange", cssVar: "--orange" },
    { value: "turquoise", text: "Turquoise", cssVar: "--turquoise" },
    { value: "pink", text: "Pink", cssVar: "--pink" },
    { value: "blue", text: "Blue", cssVar: "--blue" },
    { value: "black", text: "Black", cssVar: "--black" }
];

export const ALERT_PRESENTATION_STYLE_OPTIONS = [
    { value: AlertPresentationStyle.Standard, text: "Standard Banner" },
    { value: AlertPresentationStyle.Small, text: "Small Banner" },
    { value: AlertPresentationStyle.Icon, text: "Icon Only" }
];